module.exports = __webpack_public_path__ + "static/media/time-to-care-best-match-star.08257b4b.svg";